<template>
  <div class="player-ctrl">
    <div class="ctrl">
      <img class="bg" src="../../../assets/bobobobo.png">
      <p class="title">白噪音</p>
      <div class="content">
        <div class="play" @click="playAction">
          <img v-if="isPlay" src="../../../assets/pause.png"/>
          <img v-else class="play-icon" src="../../../assets/play.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { playAudio, pauseAudio } from '../../../utils/audio'
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState({
      isPlay: state => state.isPlay,
      selectedList: state => state.selectedList
    })
  },
  methods: {
    ...mapMutations(['updateIsPlay']),
    playAction () {
      this.isPlay ? this.pausePlay() : this.startPlay()
    },
    startPlay () {
      this.selectedList.forEach(item => playAudio(item))
      this.updateIsPlay(true)
    },
    pausePlay () {
      this.selectedList.forEach(item => pauseAudio(item))
      this.updateIsPlay(false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/style.scss';

.player-ctrl {
  @include flexCenter;
  width: 100%;
  height: 100%;
  .ctrl {
    position: relative;
    height: 70%;
    .title {
      @include transformCenter;
      top: 23%;
      color: white;
      font-size: 40px;
    }
    .bg {
      height: 100%;
    }
    .content {
      @include flexCenter;
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .play {
        position: relative;
        @include flexCenter;
        width: 150px;
        height: 150px;
        border-radius: 50%;
        border: 5px solid white;
        cursor: pointer;
        z-index: 1;
        &:hover {
          opacity: 0.8;
        }
        img {
          @include transformCenter;
          width: 40%;
          &.play-icon {
            left: 54%;
          }
        }
      }
    }
  }
}
</style>
